import numeral from 'numeral'

import {getNumberFormat} from '@base/app-services/i18n-format'

export const defaultFormat = 'us'
export const allFormats = {
  us: {
    name: 'us',
    separator: ',',
    decimalSeparator: '.',
    thousandSeparator: ',',
    decimalPlaces: 2,
    format: '0,00.00',
    editableFormat: '0.[00]',
    editableExample: '2495.98',
    compactedMilionsFormat: '0.000a',
    validationRegex: /^\d*\.?\d{0,2}$/,
    example: '123,456.78',
  },
  eu: {
    name: 'eu',
    separator: ',',
    decimalSeparator: ',',
    thousandSeparator: ' ',
    decimalPlaces: 2,
    format: '0,00.00',
    editableFormat: '0.[00]',
    editableExample: '2945,98',
    compactedMilionsFormat: '0.000a',
    validationRegex: /^\d*,?\d{0,2}$/,
    example: '123 456,78',
  },
  int: {
    name: 'int',
    separator: '',
    decimalSeparator: '.',
    thousandSeparator: ',',
    decimalPlaces: 0,
    format: '0,00[.]00',
    editableFormat: '0[.]00',
    editableExample: '2495',
    compactedMilionsFormat: '0.000a',
    validationRegex: /^\d*\.?\d{0,2}$/,
    example: '123,456',
  },
}

export function userNumberFormatName() {
  return getNumberFormat() || defaultFormat
}

export function _getFormat(formatName) {
  return allFormats[formatName]
}

export function userNumberFormat() {
  return _getFormat(userNumberFormatName())
}

export function numberToEditableString(number) {
  const format = userNumberFormat().editableFormat

  return numeral(number === null ? 0 : Number(number)).format(format)
}

export function formattedStringToNumber(string) {
  return numeral._.stringToNumber(String(string))
}
